import { useMediaQuery, useTheme } from '@mui/material';

import Shiftplan from '~/containers/Shiftplan';
import { ShiftResource } from '~/generated';
import { useShiftsForCalendarWeek } from '~/hooks/api/useShiftsForCalendarWeek';
import styles from './styles.module.css';
import WeekplanCalendar from '../WeekplanCalendar';
import { getRouteApi } from '@tanstack/react-router';

const route = getRouteApi('/weekplan/$year/$week/$day/{-$shiftId}');

export const Weekplan = () => {
  const theme = useTheme();
  const params = route.useParams();
  const year = parseInt(params.year, 10);
  const week = parseInt(params.week, 10);
  const shiftsQuery = useShiftsForCalendarWeek({ year, week });
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <div className={styles['weekplan-calendar']}>
      <div className={styles.content}>
        {params.shiftId ? (
          <>
            {isDesktop ? (
              <div>
                <WeekplanCalendar
                  shiftsData={{
                    isFetching: shiftsQuery.isLoading,
                    shifts: shiftsQuery.data as ShiftResource[],
                  }}
                />
              </div>
            ) : null}
            <div className={styles.shift}>
              <Shiftplan />
            </div>
          </>
        ) : (
          <div>
            <WeekplanCalendar
              shiftsData={{
                isFetching: shiftsQuery.isLoading,
                shifts: shiftsQuery.data as ShiftResource[],
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Weekplan;
